/**
 * Cookie Banner Component
 * Displays persistent cookie consent banner until user accepts
 */

import { getCookieManager } from '../utils/cookieManager.js';

export class CookieBanner {
  constructor() {
    this.cookieManager = getCookieManager();
    this.banner = null;
    this.acceptAllBtn = null;
    this.settingsBtn = null;
    this.init();
  }

  /**
   * Initialize the cookie banner
   */
  init() {
    this.banner = document.getElementById('cookieBanner');

    if (!this.banner) {
      console.warn('Cookie banner element not found');
      return;
    }

    this.acceptAllBtn = this.banner.querySelector('[data-cookie-accept-all]');
    this.settingsBtn = this.banner.querySelector('[data-cookie-settings]');

    // Check if consent was already given
    if (this.cookieManager.hasConsent()) {
      this.hide();
    } else {
      this.show();
    }

    this.attachEventListeners();
  }

  /**
   * Attach event listeners
   */
  attachEventListeners() {
    if (this.acceptAllBtn) {
      this.acceptAllBtn.addEventListener('click', () => this.handleAcceptAll());
    }

    if (this.settingsBtn) {
      this.settingsBtn.addEventListener('click', () => this.handleOpenSettings());
    }
  }

  /**
   * Handle accept all button click
   */
  handleAcceptAll() {
    this.cookieManager.acceptAll();
    this.hide();

    // Dispatch custom event for other components to listen to
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', {
      detail: this.cookieManager.getPreferences()
    }));
  }

  /**
   * Handle open settings button click
   */
  handleOpenSettings() {
    // Dispatch event to open cookie settings modal
    window.dispatchEvent(new CustomEvent('openCookieSettings'));
  }

  /**
   * Show the banner
   */
  show() {
    if (this.banner) {
      this.banner.classList.add('visible');
      this.banner.setAttribute('aria-hidden', 'false');
    }
  }

  /**
   * Hide the banner
   */
  hide() {
    if (this.banner) {
      this.banner.classList.remove('visible');
      this.banner.setAttribute('aria-hidden', 'true');
    }
  }

  /**
   * Clean up event listeners
   */
  destroy() {
    if (this.acceptAllBtn) {
      this.acceptAllBtn.removeEventListener('click', this.handleAcceptAll);
    }
    if (this.settingsBtn) {
      this.settingsBtn.removeEventListener('click', this.handleOpenSettings);
    }
  }
}

/**
 * Initialize cookie banner
 * @returns {CookieBanner} Instance of cookie banner
 */
export function initCookieBanner() {
  return new CookieBanner();
}
